import moment from 'moment/moment';
import { STARTS_TODAY } from './getDisplayDate';

export const getExpenseStartDate = (year: number = new Date().getFullYear()) => {
  return moment(year === STARTS_TODAY ? Date.now() : [year]).format('MM/DD/YYYY');
};
